module.exports = __webpack_public_path__ + "img/noAccidentSYJ.f4c86cfd.png";